import { useState } from 'react';
import { IBom, IModelDownloads } from 'types';

const useUpdateModelDownload = () => {
  const [bomJson, setBomJson] = useState<IBom[]>();
  const [drawingPdfUrl, setDrawingPdfUrl] = useState<string>();
  const [bomCsvUrl, setBomCsvUrl] = useState<string>();
  const [exportSatUrl, setExportSatUrl] = useState<string>();
  const [exportStpUrl, setExportStpUrl] = useState<string>();
  const [exportDwgUrl, setExportDwgUrl] = useState<string>();
  const [export2dDwgUrl, setExport2dDwgUrl] = useState<string>();

  const handleUpdateModelDownload = async ({
    outputBomCsv,
    outputBomJson,
    outputExport2dDwg,
    outputExportDwg,
    outputExportSat,
    outputExportStp,
    outputPdf,
  }: IModelDownloads) => {
    setDrawingPdfUrl(outputPdf?.url);
    setBomJson(outputBomJson);
    setBomCsvUrl(outputBomCsv?.url);
    setExportSatUrl(outputExportSat?.url);
    setExportStpUrl(outputExportStp?.url);
    setExportDwgUrl(outputExportDwg?.url);
    setExport2dDwgUrl(outputExport2dDwg?.url);
  };
  return [
    handleUpdateModelDownload,
    {
      drawingPdfUrl,
      bomJson,
      bomCsvUrl,
      exportSatUrl,
      exportStpUrl,
      exportDwgUrl,
      export2dDwgUrl,
    },
  ] as const;
};

export { useUpdateModelDownload };
